import { Container } from "../../components";
import { useContextHook } from "../../Context/ContextOPen";
import Translate from "../../Context/Translate";

import { content } from "../../lang/useLang";
import "./link.css";

const Navbar = () => {
  const { swiperIndex, setSwiperIndex, direction } = useContextHook();
  const links = [
    { id: 0, name: content.home },
    { id: 1, name: content.about_us },
    { id: 2, name: content.products },
    { id: 3, name: content.services },
    { id: 4, name: content.partners },
    { id: 5, name: content.contact_us },
  ];
  return (
    <div className="!bg-transparent max-lg:h-[8dvh] !shadowBottom">
      <Container>
        <div className="flex justify-between items-center pt-1">
          <div
            className="font-bold text-2xl text-white logo flex items-center"
            onClick={() => setSwiperIndex(0)}
          >
            {/* <img src={logo} alt="" className="w-12 -mr-2" /> */}
            <span className="text-Main ">P</span>rime-pixls
          </div>
          <ul
            style={{ direction: direction }}
            className="max-lg:hidden flex gap-10 items-center text-white py-1 text-lg font-bold transition-all cursor-pointer "
          >
            {links.map((e, i) => (
              <li
                key={i}
                className={`hover:text-Main after:bg-Main cursor-pointer link ${
                  swiperIndex === e.id || (!swiperIndex && e.id === 0)
                    ? "active text-Main"
                    : ""
                } `}
                onClick={() => {
                  setSwiperIndex(e.id);
                }}
              >
                {e.name}
              </li>
            ))}
          </ul>
          <Translate />
        </div>
      </Container>
    </div>
  );
};

export default Navbar;
